import { useTheme } from "styled-components";
import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuBody,
  DropdownMenuHeader,
  DropdownToggle,
  DropdownWrapper,
} from "./style";
import Avatar from "../Avatar";
import { Button } from "../Button/styles";
import SweetAlert from "sweetalert2";
import services from "../../services";
import useIsMobile from "../../hooks/deviceChecker";

const Component = ({ userInfo }) => {
  const isMobile = useIsMobile();
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <DropdownWrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <DropdownToggle>
        <Avatar userIcon={true}/>
      </DropdownToggle>
      <DropdownMenu isOpen={isHovered}>
        <DropdownMenuHeader>
          <b style={{ marginBottom: 5 }}>
            {userInfo?.nombre?.charAt(0).toUpperCase()}
            {userInfo?.nombre?.slice(1)}{" "}
            {userInfo?.apellido?.charAt(0).toUpperCase()}
            {userInfo?.apellido?.slice(1)}
          </b>
        </DropdownMenuHeader>
        <DropdownMenuBody>
          <Button
            style={{ width: "100%" }}
            options={{
              type: "link",
              size: "sm",
              skin: "primary",
            }}
            onClick={() => {
              SweetAlert.fire({
                title: "Cerrar Sesión",
                text: "¿Estás seguro que quieres salír?",
                showCancelButton: false,
                confirmButtonText: "Confirmar",
                allowEscapeKey: false,
                position: "center",
                width: isMobile ? "90%" : "50%",
                confirmButtonColor: theme.colors.Primary,
                preConfirm: () => {
                  services.auth.signOut(process.env.REACT_APP_MCA_URL);
                },
              });
            }}
          >
            Cerrar sesión
          </Button>
        </DropdownMenuBody>
      </DropdownMenu>
    </DropdownWrapper>
  );
};

export default Component;
